import {
  FC,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from 'react'

import { useDebounceFn, useEventListener } from 'ahooks'
import { cloneDeep } from 'lodash-es'

import { Personal } from '@/components/Personal'
import { IGroupListItem } from '@/httpRequest/modules/imInfo/groupList'
import { sessionUpdateLastReadAt } from '@/httpRequest/modules/mesperyIm/sessionUpdateLastReadAt'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'

import { getDefaultNickName } from './ContactsModal'
import { letters } from '../goup/CreateGroupStep1'
import useSWRGroupList from '../hooks/useSWRGroupList'
import styles from '../message.module.less'
import { EConversationType } from '../types/message'

export interface IGroupsProps {
  rootStyle?: React.CSSProperties
}

export const Groups: FC<IGroupsProps> = (props) => {
  const { rootStyle } = props

  const {
    currentConversation,
    setConversation,
    userGroups,
    setUserGroups,
    conversationList,
    setConversationList,
    messageData,
    setMessageData,
    searchKeyword
  } = useMessageAtom()

  const { data, setSize, size } = useSWRGroupList()
  const groupListRef = useRef<HTMLDivElement>(null)
  const [openChatUpadte, setOpenChatUpadte] = useState(false)

  const userGroupsData = useMemo(() => {
    const sortData = userGroups.sort(
      (a, b) => a.session_name.localeCompare(b.session_name || '') || 0
    )

    letters.forEach((preFix) => {
      const index = sortData.findIndex(
        (data) => data.session_name.toLocaleUpperCase()[0] === preFix
      )
      if (index !== -1) {
        sortData[index].preFix = preFix
      }
    })

    return sortData
  }, [userGroups])

  const handleUpdateLastReadAt = (last_read_at: number) => {
    sessionUpdateLastReadAt({
      last_read_at: last_read_at,
      session_id: currentConversation?.session_id || '',
      session_type: currentConversation?.session_type || 0
    })
    const sessionList = conversationList?.map((item) => {
      if (item.session_id === currentConversation?.session_id) {
        item.last_read_at = last_read_at
      }
      return item
    })
    setConversationList(sessionList)
  }

  const openChat = (chat: IGroupListItem) => {
    if (chat.session_id === currentConversation?.session_id) {
      return
    }
    setOpenChatUpadte(true)
    setMessageData({ list: [], next: false })
    setConversation({
      ...chat
    })
  }

  const handleLoadMore = () => {
    if (userGroups?.length === data?.[0]?.data.count) {
      return
    }
    setSize(size + 1)
  }

  // 防抖滚动处理
  const { run: debouncedHandleScroll } = useDebounceFn(
    () => {
      const element = groupListRef.current
      if (!element) return

      // 使用元素自身尺寸计算
      const scrollTop = element.scrollTop
      const clientHeight = element.clientHeight
      const scrollHeight = element.scrollHeight

      if (scrollTop + clientHeight >= scrollHeight - 100) {
        handleLoadMore()
      }
    },
    { wait: 200 }
  )
  useEffect(() => {
    if (messageData.list.length && currentConversation && openChatUpadte) {
      // 打开会话框时更新最后一条消息阅读时间
      handleUpdateLastReadAt(
        Number(messageData?.list[messageData.list.length - 1]?.created_at)
      )
      setOpenChatUpadte(false)
    }
  }, [messageData, currentConversation])

  useLayoutEffect(() => {
    if (data) {
      const copyData = cloneDeep(data)
      const sessionList = copyData?.reduce((acc, cur, curIndex) => {
        if (curIndex === 0) return cur

        if (cur?.data.list) {
          if (!acc) return cur

          const result = acc.data.list.concat(cur.data.list)
          acc.data.list = result
        }
        return acc
      })
      setUserGroups(sessionList?.data.list || [])
    }
  }, [data])

  useEventListener('scroll', debouncedHandleScroll, { target: groupListRef })

  return (
    <div
      ref={groupListRef}
      className={`${styles.ContactList} ${styles.ContactListRead}`}
      style={{ flex: 1, overflowY: 'scroll', ...rootStyle }}
    >
      <ul>
        {userGroupsData
          .filter((item) => {
            return item.session_name.includes(searchKeyword)
          })
          .map((item) => (
            <>
              {item.preFix && <div className="letter">{item.preFix}</div>}
              <li
                key={item.session_id}
                className={
                  currentConversation?.session_id === String(item.session_id)
                    ? 'active'
                    : ''
                }
                onClick={() => {
                  console.log(item)
                  openChat(item)
                }}
              >
                <Personal
                  userData={{}}
                  nickname={
                    item.session_name ||
                    getDefaultNickName(EConversationType.GROUP)
                  }
                  avatar={item.session_avatar_url}
                />
              </li>
            </>
          ))}
      </ul>
    </div>
  )
}
